import { render, staticRenderFns } from "./Step3Component.vue?vue&type=template&id=82ac5aec&scoped=true&"
import script from "./Step3Component.vue?vue&type=script&lang=js&"
export * from "./Step3Component.vue?vue&type=script&lang=js&"
import style0 from "./Step3Component.vue?vue&type=style&index=0&id=82ac5aec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ac5aec",
  null
  
)

export default component.exports